import { useMemo, useEffect, useState } from "react";

export function useSelectStyles() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const updateMode = () => {
      const mode = document.documentElement.getAttribute("data-layout-mode");
      setIsDarkMode(mode === "dark");
    };

    updateMode();

    const observer = new MutationObserver(updateMode);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-layout-mode"],
    });

    return () => observer.disconnect();
  }, []);

  const customStyles = useMemo(
    () => ({
      control: (provided, state) => ({
        ...provided,
        backgroundColor: isDarkMode ? "#16191c" : "#fff",
        borderColor: state.isFocused ? "#fd8e2d" : isDarkMode ? "#333" : "#ccc",
        boxShadow: state.isFocused ? "0 0 0 1px #fd8e2d" : "none",
        "&:hover": {
          borderColor: "#fd8e2d",
        },
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
          ? isDarkMode
            ? "#222"
            : "#f1f1f1"
          : isDarkMode
          ? "#111"
          : "#fff",
        color: state.isSelected ? "#fd8e2d" : isDarkMode ? "#fff" : "#000",
        padding: 12,
        cursor: "pointer",
        "&:hover": {
          backgroundColor: isDarkMode ? "#222" : "#f1f1f1",
        },
      }),
      menu: (provided) => ({
        ...provided,
        backgroundColor: isDarkMode ? "#111" : "#fff",
        zIndex: 100,
      }),
      singleValue: (provided) => ({
        ...provided,
        color: isDarkMode ? "#fff" : "#000",
        paddingTop: 8,
        paddingBottom: 8,
      }),
    }),
    [isDarkMode]
  );

  return customStyles;
}
